<template>
    <div class="alert-secondary mb-3">
        <!-- <search-filters @addFilter="addFilter"></search-filters> -->
        <b-row>
            <b-col>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-button @click="toggleFilters">
                            <b-icon-chevron-down v-if="showFilters"></b-icon-chevron-down>
                            <b-icon-chevron-right v-else></b-icon-chevron-right>
                            <span class="p-xl-2 pl-2 pr-1">Filters</span>
                        </b-button>
                    </b-input-group-prepend>

                    <b-form-input type="search" v-model="query" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-input type="search" id="catalogNumber" placeholder="Catalog number" v-model="catalogNumber" v-on:keyup.enter="search()"></b-form-input>
                    <search-history @setSearch="setSearch" />
                    <b-input-group-append>

                        <b-button variant="primary" @click="search()">Search</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <b-row class="p-3" v-if="showFilters">
   
            <b-col>
                <b-form-checkbox size="sm" class="mr-3" v-model="filters.hasImagesAdmin">Has Images</b-form-checkbox>
                <b-form-checkbox size="sm" class="mr-3" v-model="filters.noImagesAdmin">No Images</b-form-checkbox>
                <b-form-checkbox size="sm" class="mr-3" v-model="filters.isActive">Active</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.offsite">Off-site</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noDiscogsId">No Discogs ID</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noAmazonId">No Amazon ID</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noLocation">No Location</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noSource">No Source</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noPrice">No Price</b-form-checkbox>
            </b-col>


            <b-col cols="6">
                <b-input-group>
                    <b-input placeholder="Active" v-model="filters.active" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Inactive" v-model="filters.inactive" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Cover parts" v-model="filters.cover" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Disc parts" v-model="filters.disc" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Disc count" v-model="filters.discCount" size="sm" v-on:keyup.enter="search()"></b-input>
                </b-input-group>

                <b-input-group>
                    <b-input placeholder="Location From" v-model="filters.locationFrom" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Location To" v-model="filters.locationTo" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-form-select class="genreList" :options="genreList" size="sm" v-model="filters.genre">
                        <template #first>
                            <b-form-select-option :value="null">Genre</b-form-select-option>
                        </template>
                    </b-form-select>

                        <b-input v-model="filters.price" size="sm" placeholder="Price" v-on:keyup.enter="search()"></b-input>
                        <b-input-group-append>
                            <b-button class='bg-white price-tip' id="price-tooltip" size="sm"><b-icon-info-circle></b-icon-info-circle>
                                <b-tooltip placement="bottom" target="price-tooltip" variant="info" triggers="click blur">
                                <p class="text-left inline m-0">Use '>' or '&lt;' to find greater than, less than values.<br/>
                                Put ".." between two values to find a price range.<br />e.g. 100..200 will show everything between $100 and $200.
                                </p>
                            </b-tooltip>
                            </b-button>
                        </b-input-group-append>
                </b-input-group>

                <b-input-group>


                    <b-form-select :options="formatList" size="sm" v-model="filters.format">
                        <template #first>
                            <b-form-select-option :value="null">Format</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select :options="sizeOptions" size="sm" v-model="filters.size">
                        <template #first>
                            <b-form-select-option :value="null">Size</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select :options="speedOptions" size="sm" v-model="filters.speed">
                        <template #first>
                            <b-form-select-option :value="null">Speed</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select :options="conditionGrades" size="sm" v-model="filters.adminGrade">
                        <template #first>
                            <b-form-select-option :value="null">Grade</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select :options="conditionGrades78" size="sm" v-model="filters.adminGrade">
                        <template #first>
                            <b-form-select-option :value="null">78 Grade</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select v-if="filters.adminGrade" :options="conditionSubjectOptions" size="sm" v-model="filters.subject">
                        <template #first>
                            <b-form-select-option :value="null">Subject</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>

                <b-input-group>
                    <b-input v-model="filters.hype" size="sm" placeholder="Hype" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Pressing notes" v-model="filters.pressingNotes" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-form-select :options="countries" size="sm" value-field="name" text-field="name" v-model="selectedCountry" v-on:change="addPressingCountry">
                        <template #first>
                            <b-form-select-option :value="null">Pressing Country</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-input placeholder="Media attributes" v-model="filters.mediaAttrs" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input-group-append>
                            <b-button id="field-tooltip" size="sm"><b-icon-info-circle></b-icon-info-circle>
                                <b-tooltip placement="bottom" target="field-tooltip" variant="info" triggers="click blur">
                                <p class="text-left inline m-0">
                                For multiple values separate queries with a comma and a space.<br/>
                                Works in Hype, Pressing notes and Media attributes fields.<br/>
                                e.g. red wax, repro (will filter for "red wax" and "repro").
                                </p>
                            </b-tooltip>
                            </b-button>
                        </b-input-group-append>
                </b-input-group>

                <b-input-group>
                     <b-input placeholder="Source" v-model="filters.source" size="sm" v-on:keyup.enter="search()"></b-input>
                     <b-form-select :options="originList" size="sm" v-model="filters.origin">
                        <template #first>
                            <b-form-select-option :value="null">Origin</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select :options="suppressSiteList" size="sm" v-model="filters.suppressed">
                        <template #first>
                            <b-form-select-option :value="null">Suppressed On</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>



                <b-input-group>
                <b-input placeholder="Added By" v-model="filters.addedBy" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-form-datepicker size="sm"
                                    placeholder="Added From"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.added">
                    </b-form-datepicker>

                    <b-form-datepicker size="sm"
                                    placeholder="Added To"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.addedTo">
                    </b-form-datepicker>
                </b-input-group>
                <b-input-group>
                <b-input placeholder="Inactive Updated By" v-model="filters.inactiveUpdatedBy" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-form-datepicker size="sm"
                                    placeholder="Inactive Updated From"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.inactiveUpdated">
                    </b-form-datepicker>

                    <b-form-datepicker size="sm"
                                    placeholder="Inactive Updated To"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.inactiveUpdatedTo">
                    </b-form-datepicker>
                </b-input-group>
                <b-input-group>

                    <b-form-datepicker size="sm"
                                    placeholder="Photo Date"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.imageDateFrom"
                    ></b-form-datepicker>

                    <b-form-datepicker size="sm"
                                    placeholder="Photo Date To"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.imageDateTo"
                    ></b-form-datepicker>

                </b-input-group>
            </b-col>

            <b-col cols="4">
                <b-input-group>

                <b-form-datepicker size="sm"
                                   placeholder="Order From"
                                   :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                   v-model="filters.orderDate"
                ></b-form-datepicker>

                <b-form-datepicker size="sm"
                                   placeholder="Order To"
                                   :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                   v-model="filters.orderDateTo"
                                   :disabled="!this.filters.orderDate"
                ></b-form-datepicker>

                </b-input-group>

                <b-input-group>
                    <b-form-select size="sm" v-model="filters.platform" :options="platformOptions">
                        <template #first>
                            <b-form-select-option :value="null">Platform</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-input placeholder="Order Source" v-model="filters.orderSource" size="sm" v-on:keyup.enter="search()"></b-input>
                </b-input-group>

                <b-input-group>
                    <b-form-datepicker size="sm"
                                   placeholder="No Sales Since"
                                   :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                   v-model="filters.noSalesSince"
                ></b-form-datepicker>
                    <b-input placeholder="Order Item Added By" v-model="filters.orderAddedBy" size="sm" v-on:keyup.enter="search()"></b-input>
                </b-input-group>
                <b-input-group class="mt-3">
                    <b-input placeholder="Integration ID" v-model="filters.integrationId" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-input placeholder="Added By" v-model="filters.integrationAddedBy" size="sm" v-on:keyup.enter="search()"></b-input>
                    <b-form-select :options="integrationPlatforms" size="sm" v-model="filters.integrationPlatform">
                        <template #first>
                            <b-form-select-option :value="null">Int Platform</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>

                <b-input-group>

                    <b-form-datepicker size="sm"
                                    placeholder="Added"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.integrationAdded">
                    </b-form-datepicker>

                    <b-form-datepicker size="sm"
                                    placeholder="To"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.integrationAddedTo">
                    </b-form-datepicker>
                </b-input-group>

                <div class="button-holder d-flex grow-2 align-items-end justify-content-end">
                    <b-button variant="outline-primary" @click="clear" size="sm">
                        <b-icon-x></b-icon-x>
                        <span class="p-xl-1 pl-2 pr-1">Clear</span>
                    </b-button>
                </div>

            </b-col>


      
        </b-row>

        <b-modal
                id="searchFilters"
                size="md"
                scrollable
                hide-header-close
                hide-header
                button-size="sm"
                style="min-height: 300px">
            <b-input-group size="sm">
                <b-row>
                    <b-col>
                        <b-form-checkbox class="mb-2" v-model="filters.noImagesAdmin">No Images</b-form-checkbox>
                        <b-form-checkbox class="mb-2" v-model="filters.isActive">Active</b-form-checkbox>
                    </b-col>
                </b-row>
            </b-input-group>

            <b-input-group size="sm" prepend="Location">
                <b-input placeholder="From" v-model="filters.locationFrom"></b-input>
                <b-input placeholder="To" v-model="filters.locationTo"></b-input>
            </b-input-group>

            <template #modal-footer="{  }">
                <b-row class="mt-3">
                    <b-col align="right">
                        <b-button-group size="sm">
                            <b-button variant="outline-secondary" @click="clear">
                                <b-icon-x></b-icon-x>
                                <span class="p-xl-2 pl-2 pr-1">Clear</span>
                            </b-button>
                            <b-button variant="outline-primary" @click="search">
                                <b-icon-filter></b-icon-filter>
                                <span class="p-xl-2 pl-2 pr-1">Filter</span>
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import genresMixin from "../../assets/genreList";
    import formatsMixin from "../../assets/formatList";
    import originsMixin from "../../assets/originList";
    import conditionGradeOptions from "../../assets/conditionGradeOptions";
    import sizeOptions from "../../assets/sizeOptions";
    import speedOptions from "../../assets/speedOptions";
    import conditionSubjectOptions from "../../assets/conditionSubjectOptions";
    import suppressSiteList from "../../assets/suppressSiteList";
    import SearchHistory from './SearchHistory.vue';
    import platformOptions from "../../assets/platformOptions";
    import searchFilterNames from "../../assets/searchFilterNames";
    import inventoryApi from "../../api/inventory";
    import integrationPlatformOptions from "../../assets/integrationPlatformOptions";

    export default {
        name: "InventorySearch",
        components: { SearchHistory },
        mixins: [ genresMixin, formatsMixin, originsMixin, platformOptions, conditionGradeOptions, conditionSubjectOptions, searchFilterNames, inventoryApi, suppressSiteList, sizeOptions, speedOptions, integrationPlatformOptions],
        props: [ 'searchText', 'filters' ],

        data() {
            return {
                query: '',
                catalogNumber: '',
                showFilters: false,
                countries: [],
                selectedCountry: null,
            }
        },
        created() {
            this.query = this.searchText;
        },
        async mounted() {
            await this.fetchCountries();
        },
        updated() {
            if (this.filters && !this.filters.adminGrade && this.filters.subject) {
                this.filters.subject = null
            }
        },
        methods: {
            async fetchCountries() {
                const countries = await this.getCountries();
                this.countries = countries;
            },
            toggleFilters() {
                this.showFilters = !this.showFilters;
                this.$emit('showFilters', this.showFilters);
            },
            removeFilter(filterText) {
                for (let key in this.filterNames) {
                    if (filterText === this.filterNames[key]) {
                        this.$emit('removeFilter', key);
                    }
                }
            },
            addFilter(filter) {
                console.log(filter);
            },
            search() {
                this.$bvModal.hide('searchFilters');
                let search = {query: this.query, catalogNumber: this.catalogNumber, filters: this.filters}
                let recentSearches = JSON.parse(localStorage.getItem('recentSearches')) || [];

                // make sure the search isn't already saved
                if (!recentSearches.some(item => objectsAreEqual(item, search))) {
                recentSearches.unshift(search);

                // 10 most recent searches
                recentSearches = recentSearches.slice(0, 10);
                localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
                } 
                function objectsAreEqual(obj1, obj2) {
                    // Convert Vue objects to plain JavaScript objects
                    const plainObj1 = obj1.toJSON ? obj1.toJSON() : obj1;
                    const plainObj2 = obj2.toJSON ? obj2.toJSON() : obj2;

                    // Perform deep equality check
                    return JSON.stringify(plainObj1) === JSON.stringify(plainObj2);
                }
                this.$nextTick(() => {
                    this.$emit('search', search);
                });
            },
            clear() {
                this.$emit('clear');
            },

            setSearch(search) {
                this.$emit('setFilters', search.filters);
                this.query = search.query;
                this.catalogNumber = search.catalogNumber;
                this.$nextTick(()=> {this.search();});
            },

            addPressingCountry(country) {
                this.filters && this.filters?.pressingNotes && this.filters?.pressingNotes.length > 0 ? this.filters.pressingNotes = this.filters.pressingNotes + `, ${country}` : this.filters.pressingNotes = country;
                this.selectedCountry=null;
            }, 
            resetDateFrom() {
                if (this.filters && this.filters.dateFrom)
                {
                    this.$refs.orderFromDatepicker.reset();
                    this.$refs.orderToDatepicker.reset()
                 
                }
            },
            resetNoSalesSince() {
                if (this.filters && this.filters.salesSince) {
                    this.$refs.noSalesSinceDatepicker.reset()
                }
            }
        },
        computed: {
            activeFilters() {
                let active = {};
                if (this.filters) {
                    for (let key in this.filters) {
                        if (this.filters[key]) {
                            active[this.searchFilterNames[key]] = this.filters[key];
                        }
                    }
                }

                return active;
            }
        },
        watch: {
            searchText() {
                this.query = this.searchText;
            },
            'filters.orderDate': function (newOrderDate) {
                if (newOrderDate && this.filters.noSalesSince) {
                    this.filters.noSalesSince = null;
                }
            },

            'filters.noSalesSince': function (newNoSalesSince) {
                if (newNoSalesSince && this.filters.orderDate) {
                    this.filters.orderDate = null;
                    this.filters.orderDateTo = null;
                }
            },
        }
    }
</script>

<style scoped>
    .price-tip {
        color: var(--info);
        border-top: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-left: none;
        border-right: none;
    }

    .price-tip:hover, .price-tip:active, .price-tip:focus {
        color: var(--info);
        border-top: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-left: none;
        border-right: none;
        box-shadow: none;
        outline: none;
    }

    #field-tooltip {
        background-color: white;
        color: var(--info);
        border: 1px solid #ced4da;
    }

    #catalogNumber {
        max-width: 180px;
    }

    .button-holder {
        padding-top: 40px;
    }




</style>